import type { ReactElement } from 'react';

import type { CombinedCollectionGroupItem } from '@/components/CollectionGroup/types';
import type { ContentfulSelectorModalByMarketingPartnerQuery } from '@/graphql/contentful/api';
import { CmsView, type CmsViewProps } from '@/views/CmsView';
import type { EditorialViewProps } from '@/views/EditorialView/EditorialView';
import EditorialView from '@/views/EditorialView/EditorialView';

type EditorialViewWrapperProps = (EditorialViewProps | CmsViewProps) & {
  isEditorialView?: boolean;
  marketingSelectorModalResult:
    | NonNullable<
        ContentfulSelectorModalByMarketingPartnerQuery['selectorCollection']
      >['items'][0]
    | null;
  resolvedCollectionGroups?: CombinedCollectionGroupItem[] | null;
};

export const EditorialViewWrapper = (props: EditorialViewWrapperProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { resolvedCollectionGroups, ...cmsProps } = props;
  return props?.isEditorialView ? (
    <EditorialView {...(props as EditorialViewProps)} />
  ) : (
    <CmsView {...(cmsProps as CmsViewProps)} />
  );
};

EditorialViewWrapper.getLayout = (page: ReactElement) => {
  if (page.props?.isEditorialView) {
    return EditorialView.getLayout(page);
  } else {
    return CmsView.getLayout(page);
  }
};
